module.exports = __webpack_public_path__ + "img/icons8-facebook-messenger.d71cc566.svg";